import { useEffect, useState } from "react";
import c from "./styles.module.scss";
import CosmicController from "../../controllers/cosmicController";

const Announcement = () => {
  const [announcement, setAnnouncement] = useState({
    text: "",
    show: false,
    color: "",
  });

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await CosmicController.getAnnouncement();
        setAnnouncement({
          text: response.data.text,
          show: response.data.show,
          color: response.data.color || "",
        });
      } catch (err) {
        console.error("Ошибка при загрузке объявления:", err);
      }
    };

    fetchAnnouncement();
  }, []);

  if (!announcement.show) return null;

  const bgColor = announcement.color || "#f5e8e7ff";
  const textColor = announcement.color ? "#fff" : "#000";

  return (
    <div
      className={c.announcement}
      id="announcement"
      style={{ backgroundColor: bgColor }}
    >
      <div className={c.inner}>
        <p className={c.text} style={{ color: textColor }}>
          {announcement.text}
        </p>
      </div>
    </div>
  );
};

export default Announcement;
